///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { GtthCreateLinkCommand } from './create-link-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthLinkFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-link-feature-dto.model';

export class GtthRemoveLinkCommand extends GtthAbstractCommand {
    private linkId: number;
    private lineJson: GtthLinkFeatureDtoModel;
    private isDesignClear: boolean;

    getCommandName(): string {
        return 'GtthRemoveLinkCommand';
    }

    createFromId(linkId: number): this {
        this.linkId = linkId;
        return this;
    }

    doCommand(): void {
        const line = this.historyService.logicalTopology.getLink(this.linkId);
        this.lineJson = line.toGeoJson();

        this.lineJson.setToRemove(true);
        this.lineJson.setIsActive(false);

        const activity = this.createActivityDTO(false);
        activity.links = [this.lineJson];
        this.sendActivity(activity);

        line.hide();
    }

    undoCommand(): void {
        this.lineJson.setToRemove(false);
        const createLinkCommand = this.historyService.command(GtthCreateLinkCommand).createFromGeoJson(this.lineJson);
        this.historyService.doCommandBypassHistory(createLinkCommand).then((result: boolean) => {
            if (this.commandResolve) {
                this.commandResolve(result);
            }
        });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            if (this.linkId) {
                this.historyService.notificationService.showError(activityDto?.error?.message);
                const line = this.historyService.logicalTopology.getLink(this.linkId);
                line.draw();
                line.initListeners();
            }
        } else {
            const linkId = activityDto.links[0].getId();

            const line = this.historyService.logicalTopology.getLink(linkId);
            const fromStation = line.getFromStation();
            const toStation = line.getToStation();

            this.isDesignClear = !line.getLinkIsDisabled() || fromStation.isEnabled() || toStation.isEnabled();

            this.historyService.logicalTopology.removeLineFromStation(fromStation, line.getId());
            this.historyService.logicalTopology.removeLineFromStation(toStation, line.getId());

            line.hide();

            this.historyService.logicalTopology.removeLink(linkId);
            this.historyService.interactiveWindowsService.linkDelete(fromStation.getName(), toStation.getName());

            if (line.isActive()) {
                const deviceSectors = this.historyService.logicalTopology.getDeviceSectors(line.getP2mpRepSectorIndex());
                if (deviceSectors) {
                    deviceSectors.removeLinkFromSector(line);
                }
            }
        }

        if (this.commandResolve) {
            this.commandResolve(activityDto.successful);
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isModifyTopology(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return this.isDesignClear;
    }
}
